import { Grid, Button } from "@mui/material";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import FilterTable from "../../components/table/FilterTable";
import DefaultPageWrapper from "../../components/wrapper/DefaultPageWrapper";
import LoaderWrapper from "../../components/wrapper/LoaderWrapper";
import { USER_ROLES } from "../../helpers/constants";
import { useAccessControl } from "../../hooks/auth/useCheckPermission";
import usePaginationWithSearchParams from "../../hooks/usePaginationWithSearchParams";
import { useGetPersonClausesHistory } from "../../services/clausesService";
import TableService from "../../services/tableService";

import ClauseNavigationBar from "../ClausesAdminPanelPage/ClausesNavigationBar";

import { useClauseTableFieldsConfig, CLAUSE_TABLE_NAME } from "./TableFieldsConfig";

import UniversalToolBarWithDialogs from "../../components/bar/UniversalToolBarWithDialogs";

export default function ClauseHistoryPage(props) {
    const { hasAccess } = useAccessControl([USER_ROLES.SALES_MARKETING, USER_ROLES.ADMIN]);

    if (!hasAccess){
        return null
    }

    const { t } = useTranslation();
    const TRANSFER_TABLE_FIELDS_CONFIG = useClauseTableFieldsConfig();

    const { pageName } = props;
    const TABLE_CONFIGS = [{ name: CLAUSE_TABLE_NAME, config: TRANSFER_TABLE_FIELDS_CONFIG }];

    const [dataLocal, setDataLocal] = useState([]);
    const [hiddenColumnsForTables, setHiddenColumnsForTables] = useState([]);
    const [columnsOrdersForTables, setColumnsOrdersForTables] = useState([]);
    const [recordsCount, setRecordsCount] = useState(0);

    const {
        resetPageNumber,
        searchParams,
        setSearchParams,
        page: dataPage,
        pageSize: dataPageSize,
        handleChangePageWithSearchParams: handleChangeDataPage,
        handleChangePageSizeWithSearchParams: handleChangeDataPageSize,
    } = usePaginationWithSearchParams();

    const clauseSearchParams = useMemo(() => {
        const params = new URLSearchParams(searchParams);

        params.set("only_clients", true)

        return params;
    }, [searchParams]);

    const { data: clauseData, refetch, isLoading } = useGetPersonClausesHistory(clauseSearchParams);

    useEffect(() => {
        if (clauseData?.results) {
            setDataLocal(clauseData.results);
            setRecordsCount(clauseData.count);
        }
    }, [clauseData, dataPage, dataPageSize]);

    const onClickButton = useCallback((e, id) => {
        e.stopPropagation();
    }, []);

    const trnasferDataExportHeaders = useMemo(() => {
        return TableService.getTableExportHeaders(
            TRANSFER_TABLE_FIELDS_CONFIG, // @ts-ignore
            hiddenColumnsForTables?.[CLAUSE_TABLE_NAME] || [], // @ts-ignore
            columnsOrdersForTables?.[CLAUSE_TABLE_NAME] || [],
        );
    }, [TRANSFER_TABLE_FIELDS_CONFIG, hiddenColumnsForTables, columnsOrdersForTables]);

    const data = useMemo(
        () =>
            TableService.getPreparedDataForCollapsibleTable(
                TRANSFER_TABLE_FIELDS_CONFIG,
                dataLocal, // @ts-ignore
                hiddenColumnsForTables?.[CLAUSE_TABLE_NAME]
                    ? // @ts-ignore
                      hiddenColumnsForTables?.[CLAUSE_TABLE_NAME]
                    : [], // @ts-ignore
                columnsOrdersForTables?.[CLAUSE_TABLE_NAME]
                    ? // @ts-ignore
                      columnsOrdersForTables?.[CLAUSE_TABLE_NAME]
                    : [],
                onClickButton,
            ),
        [
            TRANSFER_TABLE_FIELDS_CONFIG,
            dataLocal,
            hiddenColumnsForTables,
            columnsOrdersForTables,
            onClickButton,
        ],
    );

    const tableComponent = () => (
        <FilterTable
            // @ts-ignore
            data={data}
            countRecords={recordsCount}
            resetPageNumber={resetPageNumber}
            style={{ maxHeight: "60vh" }}
            headersConfig={TableService.orderColumns(
                TableService.hideHiddenColumns(
                    TRANSFER_TABLE_FIELDS_CONFIG, // @ts-ignore
                    hiddenColumnsForTables?.[CLAUSE_TABLE_NAME] || [],
                ),
                // @ts-ignore
                columnsOrdersForTables?.[CLAUSE_TABLE_NAME] || [],
            )}
            showCleanFilterIcon={true}
            showContextMenu={false}
            showExportToFileButton={true}
            exportToFileUrl={"/customers/person-clause/export/"}
            exportToFileSearchParams={clauseSearchParams}
            exportToFileHeaders={trnasferDataExportHeaders}
            exportToFileFileName={`${t("page.clause_page.exportClauseFileName")}.xlsx`}
            showDetailsIcon={false}
            showCheckbox={false}
            page={dataPage}
            onPageChange={handleChangeDataPage}
            rowsPerPage={dataPageSize}
            onRowsPerPageChange={handleChangeDataPageSize}
            setDataLocal={setDataLocal}
            isLoading={isLoading}
        />
    );

    return (
        // @ts-ignore
        <DefaultPageWrapper tagTitle={t("headers.clauses_history")}>
            <Grid
                item
                container
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                rowSpacing={1}
                columnSpacing={2}
            >
                <Grid item xs={12}>
                    < ClauseNavigationBar />
                </Grid>
                <Grid item xs={12} marginY={1}>
                    <UniversalToolBarWithDialogs
                        pageName={pageName}
                        tableConfig={TABLE_CONFIGS}
                        refreshTable={refetch}
                        resetPageNumber={resetPageNumber}
                        hiddenColumnsForTables={hiddenColumnsForTables}
                        setHiddenColumnsForTables={setHiddenColumnsForTables}
                        columnsOrdersForTables={columnsOrdersForTables}
                        setColumnsOrdersForTables={setColumnsOrdersForTables}
                        showMassActionButton={false}
                        showOpenCloseFilterButton={false}
                        showCleanfiltersButton={false}
                        showMyFiltersButton={false}
                        showSearchButton={false}
                        style={{ marginBlock: "5px" }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <LoaderWrapper showLoader={false}>{tableComponent()}</LoaderWrapper>
                </Grid>
            </Grid>
        </DefaultPageWrapper>
    );
}
